import React, { FC, useState } from "react";
import cx from "classnames";
import { useTranslation } from "i18n";
import { dataTestIds } from "data-testids";
import {
  ChevronIcon,
  TagminAvailabilityCalendarImage as TagminCalendarIcon,
  TagminLogoImage as TagminLogo,
} from "assets";
import { IAvailabilityCalendar } from "models/suggestion";
import CalendarRecord from "./CalendarRecord";

interface Props {
  tagminAvailability: IAvailabilityCalendar;
}

const TagminAvailabilityCalendar: FC<React.PropsWithChildren<Props>> = ({
  tagminAvailability,
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="flex max-h-[180px] flex-col rounded-b-[4px]">
      <button
        className={cx(
          "flex min-h-[36px] w-full items-center gap-1 bg-color-neutral-three px-[10px] py-[5px]",
          { "rounded-b-[4px]": !isOpen }
        )}
        onClick={handleOpen}
        data-testid={
          dataTestIds.nuJobsApp[
            "MakeSuggestionsView.Card.TagminAvailabilityCalendar.TagminAvailabilityCalendar.handleOpen"
          ]
        }
      >
        <img
          src={TagminCalendarIcon}
          alt={t("agent:tagminAvailabilityCalendar.alt.calendar")}
          className="h-4"
        />
        <img
          src={TagminLogo}
          alt={t("agent:tagminAvailabilityCalendar.alt.logo")}
          className="h-[19px]"
        />
        <ChevronIcon
          width={20}
          height={20}
          className={cx("ml-auto", { "rotate-180": !isOpen })}
        />
      </button>
      {isOpen && (
        <div className="overflow-auto rounded-b-[4px]">
          {tagminAvailability.map((record) => (
            <CalendarRecord record={record} key={record.externalId} />
          ))}
          <div className="w-full rounded-b-[4px] bg-color-neutral-three text-center text-[10px]">
            {t("agent:tagminAvailabilityCalendar.limitDescr")}
          </div>
        </div>
      )}
    </div>
  );
};

export default TagminAvailabilityCalendar;
